import _ from 'lodash';
import shMenuView from './menuView.html';
import './css/adminMenu.css';
import './css/avatarDropdown.css';
import './css/commandNav.css';
import './css/footerLinks.css';
import './css/headerLinks.css';
import './css/headerNav.css';
import matchesAllWords, { splitIntoWords } from '../matchesAllWords/matchesAllWords.js';

export default function shMenuComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			name: '@',
			classes: '<',
			filter: '<',
		},
		controllerAs: 'vm',
		controller: shMenuComponentCtrl,
		template: shMenuView,
	};
}

class shMenuComponentCtrl {
	constructor(Menu) {
		'ngInject';
		// save injections
		this.Menu = Menu;
	}

	$onInit() {
		// setup
		this.cssClasses = { ...this.classes };
		if (!this.cssClasses.nav) {
			this.cssClasses.nav = 'menu-' + _.kebabCase(this.name);
		}
	}

	$onChanges(changes) {
		if (changes.filter) {
			this.buildItems();
		}
	}

	buildItems() {
		const items = this.Menu.get(this.name);
		if (this.filter) {
			this.items = this.recursivelyFilter(items, this.filter);
		} else {
			this.items = items;
		}
	}

	isActive(item) {
		return this.Menu.isActive(item);
	}

	recursivelyFilter(links, phrase) {
		const words = splitIntoWords(phrase.toLocaleLowerCase());
		const parents = [];
		links.forEach(link => {
			if (link.children && link.children.length > 0) {
				const children = [];
				link.children.forEach(child => {
					if (matchesAllWords(`${child.text} | ${child.title}`, words)) {
						children.push(child);
					}
				});
				if (children.length > 0) {
					parents.push({ ...link, children });
				}
			} else if (matchesAllWords(`${link.text} | ${link.title}`, words)) {
				parents.push(link);
			}
		});
		return parents;
	}
}
